import React from "react";
import { Phone, Mail, MapPin, Clock } from "lucide-react";
import { CONTACT, BRAND } from "../mock";
import Reveal from "./Reveal";

const WhatsAppIcon = ({ size = 18 }) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 256 256">
    <path d="M152.58,145.23l23,11.48A24,24,0,0,1,152,176a72.08,72.08,0,0,1-72-72A24,24,0,0,1,99.29,80.46l11.48,23L101,118a8,8,0,0,0-.73,7.51,56.47,56.47,0,0,0,30.15,30.15A8,8,0,0,0,138,155ZM232,128A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-40,24a8,8,0,0,0-4.42-7.16l-32-16a8,8,0,0,0-8,.5l-14.69,9.8a40.55,40.55,0,0,1-16-16l9.8-14.69a8,8,0,0,0,.5-8l-16-32A8,8,0,0,0,104,64a40,40,0,0,0-40,40,88.1,88.1,0,0,0,88,88A40,40,0,0,0,192,152Z" />
  </svg>
);

const Contact = () => {
  const cards = [
    { icon: Phone, label: "Phone", value: BRAND.phone, href: BRAND.phoneHref },
    { icon: WhatsAppIcon, label: "WhatsApp", value: BRAND.phone, href: BRAND.whatsapp },
    { icon: Mail, label: "E-Mail", value: BRAND.email, href: BRAND.emailHref },
    { icon: MapPin, label: "Address", value: BRAND.address, href: BRAND.addressMap },
  ];

  return (
    <section id="contact" className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-24 lg:py-32">
      <div className="grid lg:grid-cols-2 gap-12 items-center">
        <Reveal>
          <p className="font-body text-sm text-[#2B4BFF] font-semibold mb-3">{CONTACT.kicker}</p>
          <h2 className="font-heading font-bold tracking-tight text-4xl sm:text-5xl text-[#0B1533] leading-[1.05]">
            {CONTACT.title}
          </h2>
          <p className="font-body text-[#5A607A] mt-5 text-lg max-w-lg">{CONTACT.subtitle}</p>
          <div className="flex flex-wrap gap-3 mt-8">
            <a
              href={BRAND.phoneHref}
              className="inline-flex items-center gap-2 bg-[#2B4BFF] text-white font-body font-semibold rounded-full px-7 py-3.5 hover:bg-[#1E38D8] transition-colors duration-200"
            >
              <Phone size={18} /> Call now
            </a>
            <a
              href={BRAND.whatsapp}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 bg-[#25D366] text-white font-body font-semibold rounded-full px-7 py-3.5 hover:opacity-90 transition-opacity duration-200"
            >
              <WhatsAppIcon size={18} /> WhatsApp
            </a>
          </div>
        </Reveal>

        <div className="grid sm:grid-cols-2 gap-5">
          {cards.map((card, i) => {
            const Icon = card.icon;
            return (
              <Reveal
                key={card.label}
                delay={i * 80}
                className="group rounded-3xl border border-[#E9E5DE] bg-white p-6 hover:border-[#2B4BFF] transition-colors duration-200 block"
              >
                <a href={card.href} target="_blank" rel="noreferrer" className="block">
                  <div className="w-11 h-11 rounded-full bg-[#EEF1FF] flex items-center justify-center mb-4">
                    <Icon size={20} className="text-[#2B4BFF]" />
                  </div>
                  <p className="font-body text-xs text-[#5A607A] uppercase tracking-wider">
                    {card.label}
                  </p>
                  <p className="font-heading font-semibold text-[#0B1533] mt-1 break-words">
                    {card.value}
                  </p>
                </a>
              </Reveal>
            );
          })}
          <Reveal delay={320} className="sm:col-span-2 rounded-3xl bg-[#0B1533] p-6 flex items-center gap-3">
            <Clock size={22} className="text-[#2B4BFF]" />
            <div>
              <p className="font-body text-xs text-white/50 uppercase tracking-wider">Available</p>
              <p className="font-heading font-semibold text-lg text-white">24 / 7 · 365 days</p>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};

export default Contact;
